import {
  ModalProps,
  createUseModal,
  useFormModal,
} from "@imminently/react/context/modals";
import { Button } from "@mui/material";

import { Icon } from "@/components/Icon";
import MultilineTextInput from "@/components/MultilineTextInput";
import PatientCardModal from "@/components/PatientCardModal";
import { PatientEncounter } from "@/resources/types";
import { encounterService } from "@/services";

const { useUpdate } = encounterService;

interface SeenPatientModalProps {
  encounter: PatientEncounter;
}

const SeenPatientModal = ({ props }: ModalProps<SeenPatientModalProps>) => {
  const { encounter } = props;

  const { mutateAsync, isLoading } = useUpdate();
  const { methods, notify, close } = useFormModal({
    mode: "all",
    defaultValues: {
      note: "",
    },
  });

  const { control, handleSubmit, formState } = methods;

  const submit = (data: any) => {
    const note = data.note
      ? { text: `Patient seen with note: ${data.note}` }
      : { text: "Patient seen" };

    // Set status to seen, submit note
    mutateAsync({
      id: encounter.id,
      payload: { status: "seen", note },
    }).catch(() => {
      notify.error("Failed to update patient");
    });

    close(true);
  };

  return (
    <PatientCardModal
      title="Seen the following patient"
      encounter={encounter}
      onClose={() => close()}
    >
      <MultilineTextInput
        control={control}
        field="note"
        label="Notes..."
        rows={6}
      />

      <Button
        sx={{ ml: "auto" }}
        disabled={isLoading || !formState.isValid}
        color="success"
        startIcon={<Icon icon="check" />}
        onClick={handleSubmit(submit)}
      >
        Seen patient
      </Button>
    </PatientCardModal>
  );
};

export const useSeenPatientModal = createUseModal(SeenPatientModal);
